import { APP_HASHES } from '@src/utils/constants.util'

/**
 * Hash text content with SHA-256 and convert the result to hexadecimal.
 * @param input The text to hash.
 * @returns
 */
export async function hash(input: string, algorithm: AlgorithmIdentifier = 'SHA-256') {
  // Encode as (utf-8) Uint8Array
  const data = new TextEncoder().encode(input.toLowerCase())

  // Hash the input
  const hash = await crypto.subtle.digest(algorithm, data)

  // To display it as a string we will get the hexadecimal value of
  // each byte of the array buffer. This gets us an array where each byte
  // of the array buffer becomes one item in the array
  const uint8ViewOfHash = new Uint8Array(hash)

  // We then convert it to a regular array so we can convert each item
  // to hexadecimal strings, where characters of 0-9 or a-f represent
  // a number between 0 and 15, containing 4 bits of information,
  // so 2 of them is 8 bits (1 byte).
  const hashAsString = Array.from(uint8ViewOfHash)
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('')

  return hashAsString
}

export const MODAL_HASH_PREFIX = 'modal-'

export const isAppModalHash = (hash: string) =>
  hash.startsWith(MODAL_HASH_PREFIX) || APP_HASHES.includes(hash)
